<template>

<div align="justify" style="padding: 0;">
    <p class="h4" v-bind:style="{'border': '0px solid red', 'height': titleDiv.height + 'px', 'margin': '0'}" align="center">
        Тарифы ({{ tarifActive.title }})
    </p>
    <div align="justify" v-bind:style="{'padding-left': paddingLeft + 'px', 'font-size': fontSize}">
        
        <!--
        <p>
            <strong>Описание</strong>
        </p>
        -->
        <!--{{ contentWidth }}<br>-->
        
        <div v-bind:style="{'border': '0px solid blue', 'float': 'left', 'width': menuDiv.width + 'px', 'height': menuDiv.height + 'px'}">
            
            <div v-for="tarif in tarifs" v-bind:key="tarif.id" id="tarifsMenu"
                v-bind:style="{'background-color': tarif.backgroundColor, 'width': menuDiv.itemWidth + 'px', 'margin-right': menuDiv.itemMarginRight + 'px'}"
                v-on:click="setTarifActive(tarif)">
                {{ tarif.title }}
            </div>
            
            <div v-bind:style="{'float': 'left', 'height': '100px', 'width': '100%', 'padding-top': menuDiv.linkDownloadMarginTop + 'px'}">
                <a href="/docs/Тарифы сопр. ПП 1С на 2026 год.xlsx">Скачать в формате Excel</a>
            </div>
            
        </div>
        
        <div v-bind:style="{'border': '0px solid blue', 'float': 'left', 'width': tarifDiv.width + 'px', 'height': tarifDiv.height + 'px', 'overflow-y': 'auto'}"
            v-if="tarifActive.isSummary">
            
            <table border="1" style="width: 100%;">
                
                <tr>
                    <th style="width: 20%; text-align: center;">
                        Вид сервиса / услуги
                    </th>
                    <th v-for="tarif in tarifs" v-bind:key="tarif.id"
                        v-bind:style="{'width': '15%', 'display': tarif.displayInSummary, 'text-align': 'center'}">
                        {{ tarif.title }}
                    </th>
                </tr>
                
                <tr v-for="param in paramsInSummary" v-bind:key="param.name">
                    <th>{{ param.title }}</th>
                    <td v-for="tarif in tarifs" v-bind:key="tarif.id"
                        v-bind:style="{'width': '15%', 'display': tarif.displayInSummary, 'text-align': 'center'}"
                        v-html="tarif[param.name]">
                    </td>
                </tr>
                
            </table>
            
            
        </div>
        
        <div v-bind:style="{'border': '0px solid blue', 'float': 'left', 'width': tarifDiv.width + 'px', 'height': tarifDiv.height + 'px', 'overflow-y': 'auto'}"
            v-if="!tarifActive.isSummary">
            
            <table border="1" style="width: 100%;">
                <tr>
                    <td style="width: 50%;">Сегментация</td><td style="width: 50%; text-align: center;">{{ tarifActive.сегментация }}</td>
                </tr>
                <tr>
                    <td>Потребности</td><td>{{ tarifActive.потребности }}</td>
                </tr>
                <!--
                <tr style="background-color: yellow;">
                    <td>Услуги, предоставляемые партнёром</td>
                    <td v-html="tarifActive.видПодпискиИТС" style="text-align: center;"></td>
                </tr>
                -->
                <tr>
                    <td>Стоимость в месяц без учета прерывания договора обслуживания 1С Предприятие (руб/мес.)</td>
                    <td v-html="tarifActive.стоимостьВМесБезУчетаПрерывания" style="text-align: center;"></td>
                </tr>
                <!--<tr>
                    <td>Стоимость в месяц с учетом прерывания договора обслуживания 1С Предприятие (руб/мес.)</td>
                    <td v-html="tarifActive.стоимостьВМесСУчетомПрерывания" style="text-align: center;"></td>
                </tr>-->
                <tr>
                    <td>Включено часов работ специалиста (обновление, консультации, настройка, доработка)  в т.ч. По телефону, удаленно</td>
                    <td v-html="tarifActive.включеноЧасов" style="text-align: center;"></td>
                </tr>
                <tr>
                    <td>Минимальный срок заключения договора (мес.)</td>
                    <td style="text-align: center;">{{ tarifActive.минСрокЗаключенияДоговора }}</td>
                </tr>
                <tr>
                    <td>Порядок оплаты</td>
                    <td style="text-align: center;">{{ tarifActive.порядокОплаты }}</td>
                </tr>
                <tr v-if="tarifActive.минОбъемРаботУдаленно !== ''">
                    <td>Минимальный объем работы специалиста <u>при удаленной консультации</u> (любые работы: обновление, консультации, настройка, доработка)</td>
                    <td style="text-align: center;">{{ tarifActive.минОбъемРаботУдаленно }}</td>
                </tr>
                <tr v-if="tarifActive.минОбъемРаботВыезд !== ''">
                    <td>Минимальный объем времени работы специалиста при подаче отдельной платной заявки на разовый вызов в офис клиента</td>
                    <td style="text-align: center;">{{ tarifActive.минОбъемРаботВыезд }}</td>
                </tr>
                <tr v-if="tarifActive.стоимостьЧасаСверхТарифа">
                    <td>Стоимость часа работы специалиста сверх тарифа</td>
                    <td style="text-align: center;">{{ tarifActive.стоимостьЧасаСверхТарифа }}</td>
                </tr>
                <!--
                <tr style="background-color: yellow;">
                    <td colspan="2" style="text-align: center; font-weight: bold;">УСЛУГИ, ПРЕДОСТАВЛЯЕМЫЕ ФИРМОЙ 1С (сервисы)</td>
                </tr>
                -->
                <tr>
                    <td><b>Право на доступ к получению легальных обновлений программ на платформе "1С:Предприятие"</b></td>
                    <td style="text-align: center;">{{ tarifActive.доступКОбновлениям }}</td>
                </tr>
                <tr>
                    <td colspan="2" style="text-align: center; font-weight: bold;">Доступ к сервисам 1С</td>
                </tr>
                <tr>
                    <td>
                        <table v-bind:style="{'margin-left': tableServiceMarginLeft + 'px'}">
                            <tr>
                                <td v-bind:style="{'width': serviceImageWidth + 'px'}">
                                    <a href="https://portal.1c.ru/applications/5" target="_blank" rel="noopener">
                                        <img src="/img/1c/services/icon_1C-Reporting.png" alt="1С: Отчетность" v-bind:style="{'background-color': '#c1272d', 'width': serviceImageWidth + 'px'}">
                                    </a>
                                </td>
                                <td>
                                    <div>
                                        1С: Отчетность - отправка отчетности в контролирующие органы
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </td>
                    <td style="text-align: center;">{{ tarifActive.сервис1сОтчетность }}</td>
                </tr>
                <tr>
                    <td>
                        <table v-bind:style="{'margin-left': tableServiceMarginLeft + 'px'}">
                            <tr>
                                <td v-bind:style="{'width': serviceImageWidth + 'px'}">
                                    <a href="https://portal.1c.ru/applications/30" target="_blank" rel="noopener">
                                        <img src="/img/1c/services/icon_1C-Edo.png" alt="1С: ЭДО" v-bind:style="{'background-color': '#662d91', 'width': serviceImageWidth + 'px'}">
                                    </a>
                                </td>
                                <td>
                                    <div>
                                        1С: ЭДО - обмен юридически значимыми документами, электронными счетами-фактурами и другими электронными документами прямо из 1С:Предприятия
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </td>
                    <td style="text-align: center;">{{ tarifActive.сервис1сЭДО }}</td>
                </tr>
                <tr>
                    <td>
                        <table v-bind:style="{'margin-left': tableServiceMarginLeft + 'px'}">
                            <tr>
                                <td v-bind:style="{'width': serviceImageWidth + 'px'}">
                                    <a href="https://portal.1c.ru/applications/2" target="_blank" rel="noopener">
                                        <img src="/img/1c/services/icon_1C-Cloud-backup.png" alt="1С: Облачный архив" v-bind:style="{'background-color': '#29abe2', 'width': serviceImageWidth + 'px'}">
                                    </a>
                                </td>
                                <td>
                                    <div>
                                        1С: Облычный архив - защита баз данных «1С:Предприятие 8» посредством автоматизированного периодического копирования и архивирования на удаленных серверах в «облачном» хранилище.
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </td>
                    <td style="text-align: center;">{{ tarifActive.сервис1сОблачныйАрхив }}</td>
                </tr>
                <tr>
                    <td>
                        <table v-bind:style="{'margin-left': tableServiceMarginLeft + 'px'}">
                            <tr>
                                <td v-bind:style="{'width': serviceImageWidth + 'px'}">
                                    <a href="https://portal.1c.ru/applications/1" target="_blank" rel="noopener">
                                        <img src="/img/1c/services/icon_1C-Link.png" alt="1С: Линк" v-bind:style="{'background-color': '#f7931e', 'width': serviceImageWidth + 'px'}">
                                    </a>
                                </td>
                                <td>
                                    <div>
                                        1С: Линк организация удаленного подключения через Интернет к приложениям 1С, установленным на компьютере или сервере пользователя.
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </td>
                    <td style="text-align: center;">{{ tarifActive.сервис1сЛинк }}</td>
                </tr>
                <tr>
                    <td>
                        <table v-bind:style="{'margin-left': tableServiceMarginLeft + 'px'}">
                            <tr>
                                <td v-bind:style="{'width': serviceImageWidth + 'px'}">
                                    <a href="https://portal.1c.ru/applications/12" target="_blank" rel="noopener">
                                        <img src="/img/1c/services/icon_1C-Buh-phone.png" alt="1С: Коннект" v-bind:style="{'background-color': '#14c4b7', 'width': serviceImageWidth + 'px'}">
                                    </a>
                                </td>
                                <td>
                                    <div>
                                        1С: Коннект - технология для мгновенного гарантированного соединения с компетентным специалистом поддержки Партнера 1С или специалистами Вендоров, предоставляющих поддержку различных программных продуктов.
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </td>
                    <td style="text-align: center;">{{ tarifActive.сервис1сКоннект }}</td>
                </tr>
                <tr>
                    <td>
                        <table v-bind:style="{'margin-left': tableServiceMarginLeft + 'px'}">
                            <tr>
                                <td v-bind:style="{'width': serviceImageWidth + 'px'}">
                                    <a href="https://portal.1c.ru/applications/3" target="_blank" rel="noopener">
                                        <img src="/img/1c/services/icon_1C-Counteragent.png" alt="1С: Контрагент" v-bind:style="{'background-color': '#b06fbe', 'width': serviceImageWidth + 'px'}">
                                    </a>
                                </td>
                                <td>
                                    <div>
                                        1С: Контрагент - Автоматическое заполнение реквизитов контрагентов и организаций по ИНН и получение актуальных сведений из ФИАС; формирвоание досье контрагента – отчета со сведениями, полезными для оценки благонадежности контрагентов.
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </td>
                    <td style="text-align: center;">{{ tarifActive.сервис1сКонтрагент }}</td>
                </tr>
                <!--
                <tr>
                    <td>
                        <table v-bind:style="{'margin-left': tableServiceMarginLeft + 'px'}">
                            <tr>
                                <td v-bind:style="{'width': serviceImageWidth + 'px'}">
                                    <a href="https://portal.1c.ru/applications/13" target="_blank" rel="noopener">
                                        <img src="/img/1c/services/icon_1C-Lecture-hall.png" alt="1С: Лекторий" v-bind:style="{'background-color': '#2e3192', 'width': serviceImageWidth + 'px'}">
                                    </a>
                                </td>
                                <td>
                                    <div>
                                        1С: Лекторий – это регулярные тематические семинары экспертов и разработчиков фирмы "1С", а также приглашенных специалистов контролирующих органов (г. Москва).
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </td>
                    <td style="text-align: center;">{{ tarifActive.сервис1сЛекторий }}</td>
                </tr>
                -->
                <tr>
                    <td>
                        <table v-bind:style="{'margin-left': tableServiceMarginLeft + 'px'}">
                            <tr>
                                <td v-bind:style="{'width': serviceImageWidth + 'px'}">
                                    <a href="https://portal.1c.ru/applications/7" target="_blank" rel="noopener">
                                        <img src="/img/1c/services/icon_1C-ITS.png" alt="1С: ИТС" v-bind:style="{'background-color': '#fbb03b', 'width': serviceImageWidth + 'px'}">
                                    </a>
                                </td>
                                <td>
                                    <div>
                                        Информационная система 1С: ИТС
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </td>
                    <td style="text-align: center;">{{ tarifActive.сервис1сИТС }}</td>
                </tr>
                <tr>
                    <td>
                        <table v-bind:style="{'margin-left': tableServiceMarginLeft + 'px'}">
                            <tr>
                                <td v-bind:style="{'width': serviceImageWidth + 'px'}">
                                    <a href="https://portal.1c.ru/applications/11" target="_blank" rel="noopener">
                                        <img src="/img/1c/services/icon_1C-Auditor.png" alt="Отвечает аудитор" v-bind:style="{'background-color': '#f15a24', 'width': serviceImageWidth + 'px'}">
                                    </a>
                                </td>
                                <td>
                                    <div>
                                        Отвечает аудитор - Пользователь программ 1С имеет возможность задать вопрос по бухгалтерскому, налоговому и кадровому учету напрямую аудиторам и специалистам фирмы 1С.
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </td>
                    <td style="text-align: center;">{{ tarifActive.сервис1сАудитор }}</td>
                </tr>
                <tr>
                    <td>
                        <table v-bind:style="{'margin-left': tableServiceMarginLeft + 'px'}">
                            <tr>
                                <td v-bind:style="{'width': serviceImageWidth + 'px'}">
                                    <a href="https://portal.1c.ru/applications/10" target="_blank" rel="noopener">
                                        <img src="/img/1c/services/icon_1C-Helpdesc.png" alt="Линия консультаций" v-bind:style="{'background-color': '#009245', 'width': serviceImageWidth + 'px'}">
                                    </a>
                                </td>
                                <td>
                                    <div>
                                        Линия консультаций 1С Фирмы 1С по технической поддержке пользователей по телефону и электронной почте.
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </td>
                    <td style="text-align: center;">{{ tarifActive.сервис1сЛинияКонсультаций }}</td>
                </tr>
            </table>
            
        </div>
        
        
    </div>
    
</div>

</template>

<script>
export default {
    name: 'PageContacts',
    data: function(){
        return{
            tarifs: [],
            tarifActive: null,
            paramsInSummary: [],
            fontSize: "",
            paddingLeft: 0,
            serviceImageWidth: 0,
            tableServiceMarginLeft: 0,
            titleDiv: {
                height: 0
            },
            menuDiv: {
                width: 0,
                height: 0,
                itemWidth: 0,
                itemMarginRight: 0,
                linkDownloadMarginTop: 0
            },
            tarifDiv: {
                width: 0,
                height: 0
            }
        };
    },
    created: function(){
        this.update();
    },
    mounted: function(){
        this.windowOnResize();
    },
    computed:{
        httpPath: function(){
            return this.$store.getters.httpPath;
        },
        viewMode: function(){
            return this.$store.getters.viewMode;
        },
        contentWidth: function(){
            return this.$store.getters.contentWidth;
        },
        contentHeight: function(){
            return this.$store.getters.contentHeight;
        }
    },
    watch: {
        contentWidth: function(){
            this.windowOnResize();
        },
        contentHeight: function(){
            this.windowOnResize();
        }
    },
    methods: {
        windowOnResize: function(){
            
            this.fontSize = "medium";
            this.paddingLeft = 10;
            this.serviceImageWidth = 72;
            this.tableServiceMarginLeft = 0;
            
            let contentWidth = this.contentWidth - 230;
            
            this.titleDiv.height = 34;
            
            this.menuDiv.width = 200;
            this.menuDiv.height = 320;
            this.menuDiv.itemWidth = 180;
            this.menuDiv.itemMarginRight = 0;
            this.menuDiv.linkDownloadMarginTop = 20;
            
            this.tarifDiv.width = contentWidth;
            this.tarifDiv.height = this.contentHeight - this.titleDiv.height - 5;
            
            if(this.viewMode === "medium"){
                
                this.paddingLeft = 0;
                
                contentWidth = this.contentWidth - 10;
                
                this.menuDiv.width = contentWidth;
                this.menuDiv.height = 120;
                this.menuDiv.itemWidth = 174;
                this.menuDiv.itemMarginRight = 20;
                this.menuDiv.linkDownloadMarginTop = 0;
                
                this.tarifDiv.width = contentWidth;
                this.tarifDiv.height = this.contentHeight - this.titleDiv.height - this.menuDiv.height - 5;
                
            }
            
            if(this.viewMode === "small"){
                
                this.fontSize = "small";
                
                this.paddingLeft = 0;
                
                this.serviceImageWidth = 0;
                
                this.tableServiceMarginLeft = -15;
                
                contentWidth = this.contentWidth - 10;
                
                this.menuDiv.width = contentWidth;
                this.menuDiv.height = 110;
                this.menuDiv.itemWidth = contentWidth / 4 - 10;
                this.menuDiv.itemMarginRight = 10;
                this.menuDiv.linkDownloadMarginTop = 0;
                
                this.tarifDiv.width = contentWidth;
                this.tarifDiv.height = this.contentHeight - this.titleDiv.height - this.menuDiv.height - 5;
                
            }
            
        },
        update: function(){
            
            this.paramsInSummary = [];
            this.paramsInSummary.push({
                name: "стоимостьВМесБезУчетаПрерывания",
                title: "Стоимость в месяц"
            });
            this.paramsInSummary.push({
                name: "минСрокЗаключенияДоговора",
                title: "Минимальный срок заключения договора (мес.)"
            });
            
            let tarif =
            this.tarifAdd({
                isSummary: true,
                displayInSummary: "none",
                title: "Сводно",
                сегментация: "Магазины, оптовые точки",
                потребности: "требуется своевременная техническая помощь и бесперебойная работа магазина",
                видПодпискиИТС: "<b>соответствует итс техно</b>",
                стоимостьВМесБезУчетаПрерывания: "3000",
                //стоимостьВМесСУчетомПрерывания: "3500",
                включеноЧасов: "Техническая линия консультаци,Удаленный доступ для решения проблем, Экстренный выезд технического специалиста <span style='text-decoration: underline;'>удаленно</span> - <span style='font-weight: bold;'>без ограничений</span>, доработка,настройка, обучение новых сотрудников  - <span style='font-weight: bold;'>за отдельную оплату</span> согласно техническому заданию",
                минСрокЗаключенияДоговора: "6",
                порядокОплаты: "предоплата/помесячно",
                минОбъемРаботУдаленно: "",
                минОбъемРаботВыезд: "",
                стоимостьЧасаСверхТарифа: "",
                доступКОбновлениям: "доступно",
                сервис1сОтчетность: "не входит в тариф (платно 1 юр лицо 3900 в год)",
                сервис1сЭДО: "входит в тариф (все вход. документы - бесплатно; исход. - 50 пакетов в месяц бесплатно)",
                сервис1сОблачныйАрхив: "не входит в тариф, за дополнительную оплату",
                сервис1сЛинк: "не входит в тариф, за дополнительную оплату (цена от кол-ва месяцев)",
                сервис1сКоннект: "не входит в тариф, за дополнительную плату",
                сервис1сКонтрагент: "не входит в тариф, за дополнительную плату",
                сервис1сЛекторий: "один семинар - 900 рублей",
                сервис1сИТС: "в ограниченном объеме (раздел Методические материалы по настройке и эффективному использованию программ 1С и Рекомендации по разработке и администрированию программ 1С)",
                сервис1сАудитор: "недоступно",
                сервис1сЛинияКонсультаций: "1 консультация в месяц",
            });
            
            this.tarifAdd({
                isSummary: false,
                displayInSummary: "none",
                title: "Розн.магазины",
                сегментация: "Магазины, оптовые точки",
                потребности: "требуется своевременная техническая помощь и бесперебойная работа магазина",
                видПодпискиИТС: "<b>соответствует итс техно</b>",
                стоимостьВМесБезУчетаПрерывания: "4370",
                //стоимостьВМесСУчетомПрерывания: "3500",
                включеноЧасов: "Техническая линия консультаци,Удаленный доступ для решения проблем, Экстренный выезд технического специалиста <span style='text-decoration: underline;'>удаленно</span> - <span style='font-weight: bold;'>без ограничений</span>, доработка,настройка, обучение новых сотрудников  - <span style='font-weight: bold;'>за отдельную оплату</span> согласно техническому заданию",
                минСрокЗаключенияДоговора: "6",
                порядокОплаты: "предоплата/помесячно",
                минОбъемРаботУдаленно: "",
                минОбъемРаботВыезд: "",
                стоимостьЧасаСверхТарифа: "",
                доступКОбновлениям: "доступно",
                сервис1сОтчетность: "не входит в тариф (платно 1 юр лицо 3900 в год)",
                сервис1сЭДО: "входит в тариф (все вход. документы - бесплатно; исход. - 50 пакетов в месяц бесплатно)",
                сервис1сОблачныйАрхив: "не входит в тариф, за дополнительную оплату",
                сервис1сЛинк: "не входит в тариф, за дополнительную оплату (цена от кол-ва месяцев)",
                сервис1сКоннект: "не входит в тариф, за дополнительную плату",
                сервис1сКонтрагент: "не входит в тариф, за дополнительную плату",
                сервис1сЛекторий: "один семинар - 900 рублей",
                сервис1сИТС: "в ограниченном объеме (раздел Методические материалы по настройке и эффективному использованию программ 1С и Рекомендации по разработке и администрированию программ 1С)",
                сервис1сАудитор: "недоступно",
                сервис1сЛинияКонсультаций: "1 консультация в месяц",
            });
            
            this.tarifAdd({
                isSummary: false,
                displayInSummary: "",
                title: "Минимальный",
                сегментация: "небольшие организации, ИП",
                потребности: "Необходимость только в обновлениях, помощь обслуживающей организации не требуется. Нет необходимости в сервисах 1С",
                видПодпискиИТС: "<b>соответствует итс техно</b>",
                стоимостьВМесБезУчетаПрерывания: "2500",
                //стоимостьВМесСУчетомПрерывания: "2500",
                включеноЧасов: "<b>не включено, по отдельной платной заявке</b>",
                минСрокЗаключенияДоговора: "6",
                порядокОплаты: "предоплата/помесячно",
                минОбъемРаботУдаленно: "0,25 ч.",
                минОбъемРаботВыезд: "1 ч.",
                стоимостьЧасаСверхТарифа: "4200",
                доступКОбновлениям: "доступно (клиент устанавливает обновления самостоятельно по инструкции, полуавтом. режим)",
                //сервис1сОтчетность: "не входит в тариф (платно 1 юр лицо 3900 в год)",
                сервис1сОтчетность: "не входит в тариф",
                сервис1сЭДО: "входит в тариф (все вход. документы - бесплатно; исход. - 50 пакетов в месяц бесплатно)",
                сервис1сОблачныйАрхив: "не входит в тариф, за дополнительную оплату",
                сервис1сЛинк: "не входит в тариф, за дополнительную оплату (цена от кол-ва месяцев)",
                сервис1сКоннект: "не входит в тариф, за дополнительную плату",
                сервис1сКонтрагент: "не входит в тариф, за дополнительную плату",
                сервис1сЛекторий: "один семинар - 900 рублей",
                сервис1сИТС: "в ограниченном объеме (раздел Методические материалы по настройке и эффективному использованию программ 1С и Рекомендации по разработке и администрированию программ 1С)",
                сервис1сАудитор: "недоступно",
                сервис1сЛинияКонсультаций: "1 консультация в месяц",
            });
            
            this.tarifAdd({
                isSummary: false,
                displayInSummary: "",
                title: "Экономичный",
                сегментация: "небольшие организации, ИП",
                потребности: "Необходимость только в обновлениях, помощь обслуживающей организации не требуется. Есть необходимость в сервисах 1С",
                видПодпискиИТС: "<b>соответствует итс проф</b>",
                //стоимостьВМесБезУчетаПрерывания: "<table border='1' align='center'><tr><th style='width: 80px;'>Срок</th><th style='width: 110px;'>Стоимость</th></tr><tr><td>1 мес</td><td>4577</td></tr><tr><td>3 мес</td><td>9156</td></tr><tr><td>6 мес</td><td>17670</td></tr><tr><td>12 мес</td><td>33816</td></tr><tr><td>24 мес</td><td>60869</td></tr>",
                стоимостьВМесБезУчетаПрерывания: "4750",
                //стоимостьВМесСУчетомПрерывания: "<table border='1' align='center'><tr><th style='width: 80px;'>Срок</th><th style='width: 110px;'>Стоимость</th></tr><tr><td>1 мес</td><td>5493</td></tr><tr><td>3 мес</td><td>10986</td></tr><tr><td>6 мес</td><td>21204</td></tr><tr><td>12 мес</td><td>40572</td></tr>",
                включеноЧасов: "<b>не включено, по отдельной платной заявке</b>",
                минСрокЗаключенияДоговора: "1",
                порядокОплаты: "предоплата/помесячно",
                минОбъемРаботУдаленно: "0,25 ч.",
                минОбъемРаботВыезд: "1 ч.",
                стоимостьЧасаСверхТарифа: "4200",
                доступКОбновлениям: "доступно (клиент устанавливает обновления самостоятельно по инструкции, полуавтом. режим)",
                сервис1сОтчетность: "входит в тариф (бесплатно 1 юр лицо)",
                сервис1сЭДО: "входит в тариф (все вход. документы - бесплатно; исход. - 100 пакетов в месяц бесплатно)",
                сервис1сОблачныйАрхив: "входит в тариф",
                сервис1сЛинк: "входит в тариф (бесплатно 2 туннеля)",
                сервис1сКоннект: "входит в тариф",
                сервис1сКонтрагент: "входит в тариф",
                сервис1сЛекторий: "входит в тариф",
                сервис1сИТС: "полный доступ",
                сервис1сАудитор: "доступно",
                сервис1сЛинияКонсультаций: "нет ограничений",
            });
            
            this.tarifAdd({
                isSummary: false,
                displayInSummary: "",
                title: "Базовый",
                сегментация: "небольшие организации, ИП",
                потребности: "Требуется помощь обслуживающей организации. Есть необходимость в сервисах 1С",
                видПодпискиИТС: "<b>соответствует итс проф</b>",
                стоимостьВМесБезУчетаПрерывания: "9200",
                //стоимостьВМесСУчетомПрерывания: "5500",
                включеноЧасов: "<b>1 час</b>",
                минСрокЗаключенияДоговора: "3",
                порядокОплаты: "предоплата/помесячно",
                минОбъемРаботУдаленно: "0,25 ч.",
                минОбъемРаботВыезд: "1 ч.",
                стоимостьЧасаСверхТарифа: "3800",
                доступКОбновлениям: "доступно",
                сервис1сОтчетность: "входит в тариф (бесплатно 1 юр лицо)",
                сервис1сЭДО: "входит в тариф (все вход. документы - бесплатно; исход. - 100 пакетов в месяц бесплатно)",
                сервис1сОблачныйАрхив: "входит в тариф",
                сервис1сЛинк: "входит в тариф (бесплатно 2 туннеля)",
                сервис1сКоннект: "входит в тариф",
                сервис1сКонтрагент: "входит в тариф",
                сервис1сЛекторий: "входит в тариф",
                сервис1сИТС: "полный доступ",
                сервис1сАудитор: "доступно",
                сервис1сЛинияКонсультаций: "нет ограничений",
            });
            
            this.tarifAdd({
                isSummary: false,
                displayInSummary: "",
                title: "Стандартный",
                сегментация: "средний бизнес, бюджетные организации",
                потребности: "Требуется помощь обслуживающей организации. Есть необходимость в сервисах 1С",
                видПодпискиИТС: "<b>соответствует итс проф</b>",
                стоимостьВМесБезУчетаПрерывания: "21200",
                //стоимостьВМесСУчетомПрерывания: "13000",
                включеноЧасов: "<b>4 часа</b>",
                минСрокЗаключенияДоговора: "3",
                порядокОплаты: "предоплата/помесячно",
                минОбъемРаботУдаленно: "0,25 ч.",
                минОбъемРаботВыезд: "1 ч.",
                стоимостьЧасаСверхТарифа: "3400",
                доступКОбновлениям: "доступно",
                сервис1сОтчетность: "входит в тариф (бесплатно 1 юр лицо)",
                сервис1сЭДО: "входит в тариф (все вход. документы - бесплатно; исход. - 100 пакетов в месяц бесплатно)",
                сервис1сОблачныйАрхив: "входит в тариф",
                сервис1сЛинк: "входит в тариф (бесплатно 2 туннеля)",
                сервис1сКоннект: "входит в тариф",
                сервис1сКонтрагент: "входит в тариф",
                сервис1сЛекторий: "входит в тариф",
                сервис1сИТС: "полный доступ",
                сервис1сАудитор: "доступно",
                сервис1сЛинияКонсультаций: "нет ограничений",
            });
            
            this.tarifAdd({
                isSummary: false,
                displayInSummary: "",
                title: "Расширенный",
                сегментация: "средний бизнес, бюджетные организации",
                потребности: "Требуется помощь обслуживающей организации. Есть необходимость в сервисах 1С",
                видПодпискиИТС: "<b>соответствует итс проф</b>",
                стоимостьВМесБезУчетаПрерывания: "41000",
                //стоимостьВМесСУчетомПрерывания: "27000",
                включеноЧасов: "<b>10 часов</b>",
                минСрокЗаключенияДоговора: "1",
                порядокОплаты: "предоплата/помесячно",
                минОбъемРаботУдаленно: "поминутно",
                минОбъемРаботВыезд: "1 ч.",
                стоимостьЧасаСверхТарифа: "3200",
                доступКОбновлениям: "доступно",
                сервис1сОтчетность: "входит в тариф (бесплатно 1 юр лицо)",
                сервис1сЭДО: "входит в тариф (все вход. документы - бесплатно; исход. - 100 пакетов в месяц бесплатно)",
                сервис1сОблачныйАрхив: "входит в тариф",
                сервис1сЛинк: "входит в тариф (бесплатно 2 туннеля)",
                сервис1сКоннект: "входит в тариф",
                сервис1сКонтрагент: "входит в тариф",
                сервис1сЛекторий: "входит в тариф",
                сервис1сИТС: "полный доступ",
                сервис1сАудитор: "доступно",
                сервис1сЛинияКонсультаций: "нет ограничений",
            });
            
            this.setTarifActive(tarif);
            
        },
        tarifAdd(tarif){
            
            let id = this.tarifs.length;
            
            tarif['id'] = id;
            tarif['backgroundColor'] = "";
            
            this.tarifs.push(tarif);
            
            return tarif;
            
        },
        setTarifActive(tarif){
            
            this.tarifActive = tarif;
            
            for(let i = 0; i < this.tarifs.length; i++){
                
                let tarifCur = this.tarifs[i];
                
                if(tarifCur === this.tarifActive){
                    tarifCur.backgroundColor = "#9999ff";
                }else{
                    tarifCur.backgroundColor = "#ffff66";
                }
                
            }
    
        },
        goToHref: function(href){
            this.$router.push(href);
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    
    #tarifsMenu {
        
        border: 0px solid blue;
        
        float: left;
        
        cursor: pointer;
        
        text-align: center;
        font-weight: bold;
        
        margin-bottom: 10px;
        border-radius: 5px;
        
        padding-top: 5px;
        padding-bottom: 5px;
        
    }
    
    td {
        padding: 5px;
    }
    
</style>

